import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { isDirectionLtr } from "utils"
import KfcsItem from "./KfcsItem"
import classes from "./index.module.scss"

const KfCategoriesSidebar = (props) => {
  const {
    filteredCategories,
    selectedCategory,
    setSelectedCategory,
    setSelectedSubCategory
  } = props

  const i18n = useTranslation()[1]

  return (
    <div
      className={clsx(classes["container"],
        isDirectionLtr(i18n.language) && classes["container-ltr"]
      )}
    >
      <div className={classes["categories"]}>
        {filteredCategories.map(category =>
          <KfcsItem
            key={category._id}
            category={category}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            setSelectedSubCategory={setSelectedSubCategory}
          />
        )}
      </div>
    </div>
  )
}

export default KfCategoriesSidebar